import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Campaign, api } from "../api";

type Metrics = {
  campaign_id: string;
  by_state: { state: string; n: number }[];
  sent_last_24h: number;
  total_replies: number;
  classification_distribution: { label: string; n: number }[];
};

export default function MetricsPage() {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [data, setData] = useState<Record<string, Metrics>>({});

  useEffect(() => {
    api<{ campaigns: Campaign[] }>("/api/campaigns").then(async (r) => {
      setCampaigns(r.campaigns);
      const out: Record<string, Metrics> = {};
      await Promise.all(
        r.campaigns.map(async (c) => {
          try { out[c.id] = await api<Metrics>(`/api/metrics/${c.id}`); } catch {}
        }),
      );
      setData(out);
    });
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight mb-6">Metrics</h1>
      {campaigns.length === 0 && <div className="text-sm text-ink-500">No campaigns yet.</div>}
      <div className="space-y-4">
        {campaigns.map((c) => {
          const m = data[c.id];
          return (
            <Link to={`/campaigns/${c.id}`} key={c.id} className="card p-4 block hover:bg-ink-50">
              <div className="flex items-center justify-between mb-3">
                <div className="font-semibold">{c.name}</div>
                <div className="text-xs text-ink-500 font-mono">{c.id}</div>
              </div>
              {m ? (
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
                  <Tile label="Sent (24h)" value={m.sent_last_24h} />
                  <Tile label="Replies" value={m.total_replies} />
                  <Tile label="Pipeline" value={m.by_state.reduce((a, b) => a + b.n, 0)} />
                  <Tile label="Classified" value={m.classification_distribution.reduce((a, b) => a + b.n, 0)} />
                </div>
              ) : (
                <div className="text-xs text-ink-500">loading…</div>
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
}

function Tile({ label, value }: { label: string; value: number }) {
  return (
    <div>
      <div className="label">{label}</div>
      <div className="text-xl font-semibold">{value}</div>
    </div>
  );
}
